import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1 } from "../../../../../config/constants";
import { parseSecondsToMinutes } from "../../../../../config/functions";
// Components
import Graphic from "../../../../graphic";

const SessionDurationPlot = ({ title, sessions }) => {
  const [positions, setPositions] = useState([]);
  const [sessionDurationValues, setSessionDurationValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let sessionDuration = [];

    sessions.forEach((recording, i) => {
      positions.push(i + 1);
      sessionDuration.push(
        recording.hasOwnProperty("sessionDuration(seconds)") ? parseSecondsToMinutes(recording["sessionDuration(seconds)"]) : NaN
      );
    });

    setPositions(positions);
    setSessionDurationValues(sessionDuration);

    return () => {
      setPositions([]);
      setSessionDurationValues([]);
    };
  }, [sessions]);

  const scoreData = {
    labels: positions,
    datasets: [
      {
        data: sessionDurationValues,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
    ],
  };

  return <Graphic Title={title} Type={Line} data={scoreData} axisY={t("timeInMinutes")} axisX={t("sessions")} showLegend={false} />;
};

export default SessionDurationPlot;
